import React from 'react';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import {
	ExperienceSuccess,
	useExperienceSuccess,
} from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { useProjectAnalyticsAttributes } from '../get-project/index.tsx';

const VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME = 'viewVersionDetailsPage';

type Attributes = {
	readonly [key: string]: string | number | boolean | null;
};

type OnExperienceFail = (location: string, error: Error, additionalAttributes?: Attributes) => void;

/**
 * The function returned by this hook should be called if an "unexpected error"
 * occurs, e.g. a JavaScript exception bubbles out of the Version Details Page.
 */
export const useViewVersionDetailsPageExperienceFail = (): OnExperienceFail =>
	useExperienceFail({
		experience: VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
	});

type OnExperienceSuccess = (additionalAttributes?: Attributes) => void;

export const useViewVersionDetailsPageExperienceSuccess = (): OnExperienceSuccess =>
	useExperienceSuccess({
		experience: VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME,
	});

export const ViewVersionDetailsPageExperienceSuccessTracker = (): React.JSX.Element => {
	const projectInfo = useProjectAnalyticsAttributes();

	return (
		<ExperienceSuccess
			experience={VIEW_VERSION_DETAILS_PAGE_EXPERIENCE_NAME}
			attributes={{
				...projectInfo,
			}}
		/>
	);
};
